import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Customer } from '../state-man/models/customer.model';
import { UiService } from './ui.service';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  constructor(
    private apiService: ApiService,
    private uiService: UiService
  ) { }
  
  // version: the one that came with the list already held, or '' for none.
  public async getAll (version: string) : Promise<{ version: string, rows: Customer[] | null } | null> {      
    try {
      const ret = await this.apiService.getVersionedList('customer/active/', version)
      return ret && { version: ret.version, rows: ret.rows && Customer.buildMany(ret.rows) }
    } 
    catch (error) {     
      LoggerService.log(error + 'customer/active')    
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')   
      return null
    }
  }  

}
